// extracted by mini-css-extract-plugin
export default {"cls1":"k550e8AUbImqszf38pbc","cls2":"YFj8ZEiFFsJDsOUPdldg k550e8AUbImqszf38pbc","isTabletDown":"sqB_5d40pJV1WoWOEZZw","isPhone":"m1m1FhmSpy686KycJ7FQ"};